import { render, staticRenderFns } from "./progressPosted.vue?vue&type=template&id=bbb55e54&scoped=true&"
import script from "./progressPosted.vue?vue&type=script&lang=js&"
export * from "./progressPosted.vue?vue&type=script&lang=js&"
import style0 from "./progressPosted.vue?vue&type=style&index=0&id=bbb55e54&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbb55e54",
  null
  
)

export default component.exports